export default __webpack_public_path__ + "static/Canadas_rising_Inuit_TikTok_star-2d96332915f425513d44e30a9f0d5d84.jpg";